<template>
  <div :class="$style.reward">
    <div :class="$style.heading_box">
      <h4>ステージ特典</h4>
      <p>会員ステージに応じて人気商品の優先販売、限定クーポンなど様々な特典をご用意しております。</p>
    </div>
    <PerfectScrollbar :class="$style.table_container">
      <table :class="$style.table">
        <thead>
          <tr>
            <th>会員ステージ</th>
            <td
              v-for="stage of stageList"
              :key="stage.name"
              :class="[
                {
                  [$style.regular]: stage.name === 'REGULAR',
                  [$style.silver]: stage.name === 'SILVER',
                  [$style.gold]: stage.name === 'GOLD',
                  [$style.platinum]: stage.name === 'PLATINUM',
                },
              ]"
            >
              <h6>{{ stage.name }}</h6>
              <p>{{ stage.kana }}</p>
              <p v-if="stage.mile"
                >年間<span :class="$style.mile">{{ stage.mile.toLocaleString() }}</span
                >マイル獲得</p
              >
              <p v-else>{{ stage.description }}</p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>購入時の<br />マイル還元率</th>
            <td
              v-for="rate of rateList"
              :key="rate"
              :class="[
                {
                  [$style.regular]: rate === 3,
                  [$style.silver]: rate === 4,
                  [$style.gold]: rate === 5,
                  [$style.platinum]: rate === 7,
                },
              ]"
              >{{ rate }}%</td
            >
          </tr>
          <tr>
            <th>会員登録・<br />ステージアップ特典</th>
            <td
              v-for="reward of rewardList"
              :key="reward"
              :class="[
                {
                  [$style.regular]: reward === '店舗限定クーポン',
                  [$style.silver]: reward === '10%OFFクーポン',
                  [$style.gold]: reward === '15%OFFクーポン',
                  [$style.platinum]: reward === '20%OFFクーポン',
                },
              ]"
              >{{ reward }}</td
            >
          </tr>
          <tr>
            <th>バースデー<br />クーポン</th>
            <td
              v-for="n of 4"
              :key="n"
              :class="[
                {
                  [$style.regular]: n === 1,
                  [$style.silver]: n === 2,
                  [$style.gold]: n === 3,
                  [$style.platinum]: n === 4,
                },
              ]"
            >
              <div
                :class="[
                  $style.dot,
                  {
                    [$style.regular]: n === 1,
                    [$style.silver]: n === 2,
                    [$style.gold]: n === 3,
                    [$style.platinum]: n === 4,
                  },
                ]"
              ></div>
            </td>
          </tr>
          <tr>
            <th>大切な方への<br />ギフトクーポン</th>
            <td
              v-for="l of 4"
              :key="l"
              :class="[
                {
                  [$style.regular]: l === 1,
                  [$style.silver]: l === 2,
                  [$style.gold]: l === 3,
                  [$style.platinum]: l === 4,
                },
              ]"
            >
              <div
                :class="[
                  $style.dot,
                  {
                    [$style.regular]: l === 1,
                    [$style.silver]: l === 2,
                    [$style.gold]: l === 3,
                    [$style.platinum]: l === 4,
                  },
                ]"
              ></div>
            </td>
          </tr>
          <tr>
            <th>限定セール</th>
            <td :class="$style.regular">
              <div :class="[$style.dot, $style.regular]"></div>
            </td>
            <td :class="$style.silver">
              <div v-for="o of 2" :key="o" :class="[$style.dot, $style.silver]"></div>
            </td>
            <td :class="$style.gold">
              <div v-for="p of 3" :key="p" :class="[$style.dot, $style.gold]"></div>
            </td>
            <td :class="$style.platinum">
              <div v-for="q of 4" :key="q" :class="[$style.dot, $style.platinum]"></div>
            </td>
          </tr>
          <tr>
            <th>人気商品の<br />優先販売・予約</th>
            <td :class="$style.regular">ー</td>
            <td :class="$style.silver">
              <div :class="[$style.dot, $style.silver]"></div>
            </td>
            <td :class="$style.gold">
              <div v-for="r of 2" :key="r" :class="[$style.dot, $style.gold]"></div>
            </td>
            <td :class="$style.platinum">
              <div v-for="s of 3" :key="s" :class="[$style.dot, $style.platinum]"></div>
            </td>
          </tr>
          <tr>
            <th>イベント優先<br />ご招待</th>
            <td :class="$style.regular">ー</td>
            <td :class="$style.silver">
              <div :class="[$style.dot, $style.silver]"></div>
            </td>
            <td :class="$style.gold">
              <div v-for="t of 2" :key="t" :class="[$style.dot, $style.gold]"></div>
            </td>
            <td :class="$style.platinum">
              <div v-for="u of 3" :key="u" :class="[$style.dot, $style.platinum]"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </PerfectScrollbar>
    <AtomsConsumerButton block variant="secondary" @click="() => router.push('/mypage')"
      >会員ステージを確認する</AtomsConsumerButton
    >
  </div>
</template>

<script lang="ts" setup>
import { PerfectScrollbar } from "vue3-perfect-scrollbar"

type StageInfo = {
  name: string
  kana: string
  description?: string
  mile?: number
}

const stageList: StageInfo[] = [
  {
    name: "REGULAR",
    kana: "レギュラー",
    description: "会員登録",
  },
  {
    name: "SILVER",
    kana: "シルバー",
    mile: 1500,
  },
  {
    name: "GOLD",
    kana: "ゴールド",
    mile: 3000,
  },
  {
    name: "PLATINUM",
    kana: "プラチナ",
    mile: 6000,
  },
]
const rateList = [3, 4, 5, 7]

const rewardList = ["店舗限定クーポン", "10%OFFクーポン", "15%OFFクーポン", "20%OFFクーポン"]
const router = useRouter()
</script>

<style scoped module lang="scss">
.reward {
  padding: 0 1rem 44px 1rem;
  border-bottom: 1px solid $primary-20;
  margin-bottom: 44px;

  h4 {
    @include main-font;
    margin-bottom: 18px;
    font-size: $font-size-20;
    color: $primary;
  }

  h5 {
    @include main-font;
    font-size: $font-size-15;
    color: $primary;
    margin-bottom: 18px;
  }

  h6 {
    font-size: $font-size-19;
    @include main-font;
  }

  .heading_box {
    margin-bottom: 18px;
  }

  .table_container {
    overflow-x: scroll;
    margin-bottom: 40px;
    .table {
      border-spacing: 0;
      border-collapse: separate;
      border: 1px solid $black-20;
      width: 920px;
      table-layout: fixed;

      th,
      td {
        padding: 1rem;
        font-size: $font-size-12;
        text-align: center;
        white-space: nowrap;
        border-right: 1px solid $black-20;
        border-bottom: 1px solid $black-20;
      }

      th {
        background-color: #faf5ee;
      }

      thead {
        th {
          font-size: $font-size-12;
          font-weight: normal;
        }
        td {
          text-align: left;
          vertical-align: baseline;

          &.regular {
            background-color: $secondary-20;
          }
          &.silver {
            background-color: #f4f4f4;
          }
          &.gold {
            background-color: #faf5ee;
          }
          &.platinum {
            background-color: #ebebeb;
          }

          .mile {
            font-size: $font-size-22;
            font-weight: bold;
            margin: 0 0.25rem 0 0.5rem;
          }
        }
      }

      tbody {
        th {
          font-size: $font-size-12;
          font-weight: normal;
        }

        td {
          &.regular {
            background-color: $secondary-10;
          }
          &.silver {
            background-color: #f6f6f6;
          }
          &.gold {
            background-color: #fdf9f6;
          }
          &.platinum {
            background-color: #f1f1f1;
          }
        }

        .dot {
          width: 14px;
          height: 14px;
          border-radius: 50%;
          margin-right: 5px;
          display: inline-block;
          &.regular {
            background-color: #b7ceed;
          }
          &.silver {
            background-color: #c8c8c8;
          }
          &.gold {
            background-color: $tertiary;
          }
          &.platinum {
            background-color: #a3a3a3;
          }
        }
      }
    }
  }
}
</style>
